
import PropTypes from "prop-types";
import { useState } from "react";
import { Typography, TextField } from "@mui/material";


function Postcode({
  label,
  inputLabel,
  formState,
  setFormState,
  setFormError,
}) {
  const [ value, setValue ] = useState("");

  function onChange(e) {
    const inputValue = e.target.value;
    // Remove spaces and convert to uppercase
    const cleanedValue = inputValue.replaceAll(' ', '').toUpperCase();
    
    // Allow partial postcode patterns during typing
    const partialPostcodeRegex = /^([A-Z]{0,2}\d?[A-Z\d]?\d?[A-Z]{0,2})$/i;
    const inputValid = partialPostcodeRegex.test(cleanedValue) || cleanedValue === "";

    if (inputValid) {
      setValue(cleanedValue);
      setFormState({
        ...formState,
        [e.target.name]: cleanedValue,
      });
      setFormError(null);
    }
  }

  return (
    <>
      <Typography
        id='postcodeLabel'
        component='label'
        htmlFor='postcodeInput'
        sx={{
          fontWeight: "bold"
        }}
      >
        {label}
      </Typography>
      <TextField
        id='postcodeInput'
        margin='dense'
        required
        fullWidth
        label={inputLabel}
        name='postcode'
        onChange={onChange}
        value={value}
      />
    </>
  );
};

const validatePostcode = (postcode) => {
  const postcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i;
  return postcodeRegex.test(postcode);
};

Postcode.propTypes = {
  label: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setFormError: PropTypes.func.isRequired,
};

export { Postcode, validatePostcode };